///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2024 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { createSlice } from "@reduxjs/toolkit";

import { getStrategicQuantile } from "../api/strategicQuantile";

export const initialState = {
  isFailure: false,
  isFetching: false,
  strategicQuantile: null
};

const strategicQuantileSlice = createSlice({
  name: "strategicQuantile",
  initialState,
  reducers: {
    requestStrategicQuantile: state => {
      state.isFetching = true;
      state.isFailure = false;
    },
    receiveStrategicQuantileSuccess: (state, { payload }) => {
      state.strategicQuantile = payload;
      state.isFetching = false;
      state.isFailure = false;
    },
    receiveStrategicQuantileFailure: state => {
      state.isFailure = true;
      state.isFetching = false;
    }
  }
});

export const {
  requestStrategicQuantile,
  receiveStrategicQuantileSuccess,
  receiveStrategicQuantileFailure
} = strategicQuantileSlice.actions;

export const strategicQuantileReducer = strategicQuantileSlice.reducer;

export const fetchStrategicQuantile = () => async dispatch => {
  dispatch(requestStrategicQuantile());
  try {
    const response = (await getStrategicQuantile()).data;

    dispatch(receiveStrategicQuantileSuccess(response));
  } catch {
    dispatch(receiveStrategicQuantileFailure());
  }
};
